import * as React from 'react';
import { Link } from 'react-router-dom';
import classes from './WebsiteVideoGuidesPage.module.css';

interface VideoGuide {
  title: string;
  description: string;
  embedUrl: string;
  iframeTitle: string;
}

const videoGuides: VideoGuide[] = [
  {
    title: 'How to use your Institution Homepage and Calendar',
    description: "Learn how to find your institution's homepage, view upcoming events, and manage your calendar.",
    embedUrl: 'https://www.youtube.com/embed/5zT_hnKsE4s?si=SBS8cm4WLV5dAZWk',
    iframeTitle: 'How to use your Institution Homepage and Calendar',
  },
  {
    title: 'How to Attend, Submit Feedback & Download Certificates',
    description: 'Learn how to join an event, complete feedback, and instantly download your attendance certificate.',
    embedUrl: 'https://www.youtube.com/embed/gJVax0GD-Fs',
    iframeTitle: 'How to register attendance, submit feedback and claim certification',
  },
  {
    title: 'How to Create an Event',
    description: 'Step-by-step guide to listing your own events, webinars, or courses on Careerbook.',
    embedUrl: 'https://www.youtube.com/embed/UZfJF1mW3a4?si=CeKDJrQ4Miro-Q-J',
    iframeTitle: 'How to Create an Event',
  },
  {
    title: 'Managing Events',
    description: 'Step-by-step guide to managing your events on Careerbook.',
    embedUrl: 'https://www.youtube.com/embed/-3JSIYFkpyM',
    iframeTitle: 'Managing Events',
  },
  {
    title: 'How to Register on Careerbook',
    description: 'Quick tutorial to set up your Careerbook account and get started.',
    embedUrl: 'https://www.youtube.com/embed/JRUNgntgJRQ',
    iframeTitle: 'How to Register on Careerbook',
  },
  {
    title: 'How to Manage Your Institution & Groups',
    description: "For education leads: learn how to manage your institution's profile, events, and learner groups.",
    embedUrl: 'https://www.youtube.com/embed/p3pFA9wIyj0',
    iframeTitle: 'How to manage groups and cohorts',
  },
  {
    title: "How to track users' attendance, feedback and certificates",
    description: 'Guide for tracking the attendance, feedback and certificates of your members.',
    embedUrl: 'https://www.youtube.com/embed/Fe-wlToLKW8',
    iframeTitle: "How to track users' attendance, feedback and certificates",
  },
];

export const WebsiteVideoGuidesPage = (): React.JSX.Element => (
  <div className={classes.Page}>
    <header className={classes.Hero}>
      <p className={classes.Tagline}>Video Guides</p>
      <h1 className={classes.Title}>Video Guides</h1>
      <p className={classes.Subtitle}>Using Careerbook Step-by-Step</p>
    </header>

    <p className={classes.Introduction}>
      Watch these quick video guides to learn how to use Careerbook&apos;s most popular features. Perfect for new and
      existing users, these videos help you get the most out of the platform with clear, visual instructions.
    </p>

    <div className={classes.Guides}>
      {videoGuides.map((guide) => (
        <section className={classes.Guide} key={guide.embedUrl}>
          <h2>{guide.title}</h2>
          <p>{guide.description}</p>
          <div className={classes.VideoFrame}>
            <iframe
              src={guide.embedUrl}
              title={guide.iframeTitle}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              loading="lazy"
            />
          </div>
        </section>
      ))}

      <section className={classes.Support}>
        <h2>Still need more help?</h2>
        <p>
          <Link to="/website/contact-us">Reach out to our support team here</Link>
        </p>
      </section>
    </div>
  </div>
);
